import styled from "styled-components";

export const StoreBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: auto;
    gap: 20px;
`
export const StoreGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    border-top: 1.5px lightgray solid;
    border-left: 1.5px lightgray solid;
        @media (max-width: 768px) {
            grid-template-columns: 1fr 1fr 1fr;
        }
        @media (max-width: 1024px) and (min-width: 769px) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }

`

export const Title = styled.h2`
    text-align: "left";
    margin: "20px 0" ;
    color: #636363;
    font-weight: 900;
    font-family: 'Lato';
`

export const TitleBox = styled.div`
    width: 100%;
    margin: 20px 0px 0px 25px;
    @media (max-width: 768px) {
        margin-left: 0px;
        padding-left: 25px;
    }
`

export const StoreImage = styled.img`
    height: auto;

    @media (max-width: 768px) {
        width: 100px;
    }

`

export const StoreImageBox = styled.div`
    display: flex;
    justify-content: center; 
    align-items: "center";
    border-right: 1.5px lightgray solid;
    border-bottom: 1.5px lightgray solid;
    padding: 15px;
    cursor: pointer;

    &:hover {
        box-shadow: inset 0 0 10px #4196cb;
    }
`

export const alphabetButtons = styled.div`
    cursor: pointer;
    color: white;
    width: 30px;
    text-align: center;
    font-weight: 900;
    font-family: 'Lato';
    border-radius: 1px;


    &:hover {
        background-color: white;
        color: #4196cb;
    }

    @media (max-width: 768px) {
        width: 43px;
        height: 40px;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

`

export const alphabetButtonsBox = styled.div`
    background-color: #4196cb;
    width: 100%;
    display: flex;
    justify-content: center;
    height: 40px;
    align-items: center;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        flex-wrap: wrap;
        height: auto;
        padding: 0px 20px;
        width: auto;
    }
`

export const StoreListBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 1080px;
    @media (max-width: 768px) {
        grid-template-columns: 1fr ;
        width: 100%;
    }
    @media (max-width: 1024px) and (min-width: 769px) {
        grid-template-columns: 1fr 1fr 1fr;
        width: 650px;
    }
`

export const Letter = styled.div`
    font-size: 64px;
    font-weight: 900;
    font-family: 'Lato';
    color: #4196cb;
    width: 120px;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const LetterBox = styled.div`
    display: flex;
    padding: 25px 0px;
    border-top: 1px solid gray;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const ListBox = styled.div`
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
        width: 90%;
    }
`

export const StoreLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  font-family: 'Lato';
  color: inherit;

    &:hover {
        text-decoration: underline;
    }
    @media (max-width: 1024px) {
        line-height: 1.8;
    }
`